export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14057.62c96c1d.jpg";